import { render, staticRenderFns } from "./ShareCaseModal.vue?vue&type=template&id=243b52e8&"
import script from "./ShareCaseModal.vue?vue&type=script&lang=js&"
export * from "./ShareCaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports